import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { ApiUrlService } from '@app/shared/services/api-url.service';
import { HTTP_DISABLE_API_PREFIX } from './http-context';

export function applyApiPrefix(request: HttpRequest<any>, apiUrlService: ApiUrlService): HttpRequest<any> {
  // Absolute URLs (e.g. presigned S3 storage links such as transcript .s2t files)
  // must not be prefixed with the API base url.
  if (request.url.startsWith('http://') || request.url.startsWith('https://')) {
    return request;
  }
  return request.clone({ url: `${apiUrlService.getApiUrl()}api/v1/${request.url}` });
}

export const apiPrefixInterceptorFn: HttpInterceptorFn = (request, next) => {
  if (request.context.get(HTTP_DISABLE_API_PREFIX)) {
    return next(request);
  }
  return next(applyApiPrefix(request, inject(ApiUrlService)));
};
